<template>
  <div
    class="page-container"
    ref="pageContainer"
    :class="{
      'page-container__full': isFullScreen && (isH5 || openAiMode),
      'component-container': isComponent,
      'focus-mode': sidebarCollapsed,
      'page-container__electron': isElectron,
    }"
  >
    <custom-player
      :lessonInfo="{
        id: Number(lessonId),
        unit_id: unitId,
        course_id: courseId,
        lesson_type: lessonType || lessonInfo.lesson_type,
        cover_url:
          lessonDetail.cover_url || courseInfo.cover_url || $route.query.coverUrl,
        risk_control_switch: riskConfigSwitch,
      }"
      ref="dplayer"
      :startTime="lastProgressTime"
      :jumpPlayTime="jumpPlayTime"
      :title="lessonDetail.lesson_name || ''"
      :orgName="
        riskConfigSwitch === 1 && riskConfig.org_watermark_switch === 1
          ? lessonDetail.org_name
          : ''
      "
      :show-back="showBack"
      :fullScreenStatus="isFullScreen"
      :isShowTop="isShowTop !== null ? isShowTop : !isComponent"
      :isComponent="isComponent"
      @back="goCourseDetails"
      @toggleFullScreen="toggleFullScreen"
      @afresh="afresh"
      :openAiMode="openAiMode"
      @videoDurationChange="videoDurationChange"
      @changeFullScreenStatus="isFullScreen = $event"
      :noteComponentId="noteComponentId"
      :urlProgressTime="urlProgressTime"
      :subtitleUrl="subtitleUrl"
      :subtitleSwitch="subtitleSwitchVal"
      :lesson-id="lessonId"
      :video-index="currentIndex"
      @quiz-active-change="$emit('quiz-active-change', $event)"
      @quiz-input-mode-change="handleQuizInputModeChange"
    ></custom-player>
    <lesson-ended-card
      v-if="playEnded"
      :next-lesson="nextLesson"
      :last-tip="lastTip"
      @replay="handleReplay"
      @next="$emit('playNext', nextLesson)"
    />
    <el-button class="enroll-btn" v-if="!isEnroll" @click="handleEnroll"
      >去报名</el-button
    >
    <div
      v-if="riskConfigSwitch === 1"
      class="watermask-container"
      :class="{ 'watermask-full-screen': isFullScreen }"
      style="pointer-events: none"
    >
      <Watermark
        :lessonDetail="lessonDetail"
        :userName="userName"
        :videoDuration="videoDuration"
      ></Watermark>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from "vuex";
import { isHXApp, isMobile, isH5 } from "@saas/components/src";
import {
  playbackKeepAlive,
  getLessonDetail,
} from "@saas/service-api/src/learning-center";
import CustomPlayer from "./components/CustomPlayer.vue";
import { checkLesson } from "@saas/service-api/src/learning-center";
import Watermark from "./components/Watermark.vue";
import LessonEndedCard from "./components/LessonEndedCard.vue";
import { isOnDemandLikeLessonType } from "@saas/components/src/utils/lesson-type";
export default {
  name: "Replay",
  props: {
    noteComponentId: {
      type: [String, Number],
      default: null,
    },
    openAiMode: {
      type: Boolean,
      default: false,
    },
    isComponent: {
      type: Boolean,
      default: false,
    },
    componentParams: {
      type: Object,
      default: () => ({}),
    },
    lessonInfo: {
      type: Object,
      default: () => ({}),
    },
    courseInfo: {
      type: Object,
      default: () => ({}),
    },
    initFullScreen: {
      type: Boolean,
      default: false,
    },
    jumpPlayTime: {
      type: Number,
      default: 0,
    },
    sidebarCollapsed: {
      type: Boolean,
      default: false,
    },
    isShowTop: {
      type: Boolean,
      default: null,
    },
    // 目录里的下一节可播课时，由宿主页面算好传进来；null 表示已是最后一节
    nextLesson: {
      type: Object,
      default: null,
    },
    // nextLesson 为 null 时的提示文案，宿主按原因定制
    lastTip: {
      type: String,
      default: "已是最后一节",
    },
    // 挂载后直接起播。只给"播放下一节"这条路用——用户点过按钮了，
    // 再让他去点一次播放键说不过去。首次进页面仍保持手动播放。
    autoPlay: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CustomPlayer,
    Watermark,
    LessonEndedCard,
  },
  data() {
    return {
      userName: "", //水印用户信息
      isMobile: isMobile(),
      isHXApp: isHXApp(),
      isH5: isH5(),
      videoList: [],
      lessonDetail: {},
      dp: null,
      currentIndex: 0,
      unitId: 0,
      lessonId: 0,
      lessonType: 0,
      courseId: 0,
      // 心跳定时器
      timerId: null,
      // 心跳延时器
      timerOutId: null,
      // 上次调用心跳接口的时间
      lastCallTime: 0,
      // 暂停剩余时间
      pauseRemainingTime: 0,
      // 是否第一次播放
      isFirstPlay: true,
      progress: 0,
      trialDuration: 0,
      startTrialDuration: 0,
      isPause: false,
      showBack: false,
      // 跑马灯还是固定展示水印
      isScroll: false,
      // 开启风险控制 1开启 2关闭
      riskConfigSwitch: 1,
      riskConfig: {},
      // 10分钟间隔
      durationTime: 10 * 60 * 1000,
      showNotice: true,
      scrollInterval: null,
      scrollTimeout: null,
      isFullScreen: false,
      restoreLandscapeAfterQuizInput: false,
      isTeacher: false,
      isElectron: window.isElectron,
      // 上次播放进度
      lastProgressTime: 0,
      videoDuration: 0,
      // 是否竖屏视频
      isPortraitVideo: false,
      // 字幕 (本地状态，非 Vuex)
      subtitleUrl: "",
      subtitleSwitchVal: 2,
      // 本节所有分片都放完了，显示结束卡片
      playEnded: false,
      // 待起播标记。视频源要等 checkLesson 返回后才有，所以先把意图记下来，
      // 到 dealPlay() 真正拿到地址时再消费。
      autoPlayPending: false,
    };
  },
  computed: {
    ...mapState("replay", ["urlProgressTime"]),
    ...mapGetters(["user"]),
    // 是否报名
    isEnroll() {
      return (
        !!this.courseInfo?.enrollment ||
        Number(this.$route.query.isEnroll)
      );
    },
    resolvedCourseId() {
      return (
        this.courseId ||
        this.courseInfo.id ||
        this.courseInfo.course_id ||
        this.lessonInfo.course_id ||
        this.$route?.params?.courseId ||
        ""
      );
    },
  },
  mounted() {
    let params = {};
    if (this.componentParams?.lessonId) {
      params = this.componentParams;
    } else {
      params = this.$route.params;
    }
    const { courseId = 0, unitId = 0, lessonId = 0 } = params;
    this.courseId = courseId;
    this.unitId = unitId;
    this.lessonId = lessonId;
    this.autoPlayPending = this.autoPlay;
    this.checkLesson();
    this.initDplay();
    // 返回按钮展示
    if (!this.$route.query.trial) {
      this.showBack = true;
    }
    this.setUserName(this.$store.getters.user);
    //全屏监听
    document.addEventListener("fullscreenchange", (event) => {
      if (document.fullscreenElement) {
        this.isFullScreen = true;
        console.log("----------------现在是全屏------------------");
      } else {
        this.isFullScreen = false;
        console.log("----------------现在是非全屏------------------");
      }
      this.$emit("fullScreenChange", this.isFullScreen);
    });
  },
  methods: {
    ...mapMutations("replay", ["setInitNoteContent", "setUrlProgressTime", "setSubTitle", "setSubtitleSwitch"]),
    videoDurationChange(duration) {
      this.videoDuration = duration;
      this.$emit("videoDurationChange", duration);
    },
    setUserName(newVal) {
      if (newVal) {
        this.userName = `${newVal.nickname || "-"}（${newVal.user_id || "-"}）`;
      } else {
        this.userName = ``;
      }
    },
    goCourseDetails() {
      this.$router.back();
    },
    isSameComponentParams(newVal = {}, oldVal = {}) {
      return ["courseId", "unitId", "lessonId"].every(
        (key) => String(newVal?.[key] || "") === String(oldVal?.[key] || "")
      );
    },
    // 心跳接口请求
    callKeepAlive(url) {
      const courseId = this.resolvedCourseId;
      if (!courseId || !this.lessonId) return;
      const videoUrl = url || this.videoList[this.currentIndex]?.url;
      if (!videoUrl) return;
      playbackKeepAlive({
        course_id: courseId,
        lesson_id: +this.lessonId,
        client_type: 1,
        play_time: new Date().getTime(),
        video_url: videoUrl,
        video_progress_time: this.progress,
        video_speed: this.dp?.video?.playbackRate || 1,
        video_index: this.currentIndex + 1,
      });
      this.lastCallTime = new Date().getTime();
    },
    // 定时器开始
    startTimer() {
      if (this.pauseRemainingTime > 0) {
        // 如果有暂停时剩余的时间，直接使用这个时间
        this.timerOutId = setTimeout(() => {
          this.callKeepAlive();
          this.startTimer();
        }, this.pauseRemainingTime);
        this.pauseRemainingTime = 0;
      } else {
        // 否则，每隔一分钟调用一次
        clearInterval(this.timerId);
        this.timerId = setInterval(this.callKeepAlive, 60 * 1000);
      }
    },
    // 定时器结束
    stopTimer() {
      clearInterval(this.timerId);
      clearTimeout(this.timerOutId);
      this.timerId = null;
      this.timerOutId = null;
      const now = Date.now();
      const remainingTime = 60 * 1000 - (now - this.lastCallTime);
      this.pauseRemainingTime = Math.max(0, remainingTime);
    },
    checkLesson() {
      const courseId = this.resolvedCourseId;
      if (!courseId || !this.lessonId) {
        return;
      }
      checkLesson({ course_id: courseId, lesson_id: this.lessonId }).then(
        (res) => {
          if (res.code === 1) {
            this.getLessonDetail();
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    // 获取课时详情
    getLessonDetail() {
      const courseId = this.resolvedCourseId;
      if (!courseId || !this.lessonId) {
        return;
      }
      getLessonDetail({
        course_id: courseId,
        lesson_id: this.lessonId,
      })
        .then((res) => {
          if (res.code === 1) {
            this.lessonDetail = res.data || {};
            this.$emit("lessonInfo", this.lessonDetail);
            // 提取字幕信息
            const material = res.data?.material || {};
            const rawSubtitle = material.subtitle || "";
            let subtitleUrl = rawSubtitle;
            if (rawSubtitle && !rawSubtitle.startsWith("http")) {
              subtitleUrl = process.env.NODE_ENV === "development"
                ? `/${rawSubtitle.replace(/^\//, "")}`
                : `${process.env.VUE_APP_CDN_URL}/${rawSubtitle.replace(/^\//, "")}`;
            }
            this.subtitleUrl = subtitleUrl;
            this.setSubTitle(subtitleUrl);
            this.subtitleSwitchVal = material.subtitle_switch ?? 2;
            this.setSubtitleSwitch(this.subtitleSwitchVal);
            // this.startTrialDuration =
            //   (res.data.trial_duration || 0) * 60 -
            //   (res.data.video_progress_time || 0);
            this.trialDuration = (res.data.trial_duration || 0) * 60;
            this.lessonType = res.data.lesson_type;
            this.isTeacher = res.data.is_teacher;
            this.lastProgressTime = res.data.video_progress_time || 0;
            this.currentIndex = res.data.video_index
              ? res.data.video_index - 1
              : 0;
            this.riskConfigSwitch = res.data.risk_control_switch;
            this.riskConfig = res.data.risk_control_config || {};
            const videoUrl = isOnDemandLikeLessonType(this.lessonType)
              ? this.lessonDetail.video_url || ""
              : this.lessonDetail.record_url || "";
            this.videoList = videoUrl.split(",").map((item) => {
              return {
                url: item,
              };
            });
            this.dealPlay();
            let isElectron = window.isElectron ?? false;
            if (isElectron) {
              document.title = this.lessonDetail.lesson_name;
              if (window.screenCaptureSwitch) {
                window.screenCaptureSwitch({
                  isEnter: true,
                  disableRecord: res.data.risk_control_switch == 1,
                });
              }
            }
          } else if (res.code === 40000) {
            this.$message.error(res.message);
            setTimeout(() => {
              this.$router.push({ name: "myCourse" });
            }, 1500);
          } else if (res.code === 40007) {
            // 开启网页防火墙
            // this.$router.replace("/firewall/" + this.courseId);
          } else if (res.code !== 10045) {
            // 10045:未到课时发布时间
            this.$message.error(res?.message || "请求失败");
          }
        })
        .catch((err) => {
          console.log("回放页面请求课时详情失败", err);
        });
    },
    // 试学时间校验
    checkTrialDuration() {
      if (this.trialDuration <= 0) {
        return;
      }
      const duration = this.startTrialDuration + this.dp.video.currentTime;
      if (duration >= this.trialDuration) {
        if (!this.isPause) {
          if (this.lessonDetail.is_sign_up) {
            // 已报名
            this.$message.error("试学时间已到，无法继续观看");
          } else {
            this.$message.error("试学时间已到，如对课程感兴趣可立即报名");
          }
        }
        this.isPause = true;
        this.dp.pause();
        this.dp.seek(this.trialDuration - this.startTrialDuration);
      }
    },
    handleSideAndTopBar(show = false) {
      let value = "none";
      if (show) {
        value = "";
      }
      let selectors = [".side-bar", ".topbar", ".windows", ".mac-bars"];
      if (this.openAiMode) {
        selectors.push(
          ".video-slice-retryable-wrapper",
          ".ai-right-operation-component",
          ".video-player-wrap .lesson-name-wrap"
        );
      }
      selectors.forEach((item) => {
        let eleItem = document.querySelector(item);
        if (eleItem) {
          eleItem.style.display = value;
        }
      });
    },
    toggleFullScreen() {
      this.setInitNoteContent();
      const element = this.$refs.pageContainer;
      if (window.isElectron) {
        if (this.isFullScreen) {
          window.ReplyElectronApi.exitFullScreen();
          this.handleSideAndTopBar(true);
        } else {
          window.ReplyElectronApi.fullScreen();
          this.handleSideAndTopBar();
        }
        this.isFullScreen = !this.isFullScreen;
        this.$emit("fullScreenChange", this.isFullScreen);
        return;
      } else if (this.isMobile) {
        this.isFullScreen = !this.isFullScreen;
        this.$store.commit("common/setShowH5Footer", !this.isFullScreen);
        if (this.isFullScreen) {
          // 竖屏视频，或 PAD 设备，不要强制旋转为横屏样式
          const isPad = window.innerWidth >= 768 && window.innerHeight >= 500;
          if (this.isPortraitVideo || isPad) {
            document.body.classList.add("replay-portrait-fullscreen");
          } else {
            document.body.classList.add("replay-landscape");
          }
        } else {
          document.body.classList.remove("replay-landscape");
          document.body.classList.remove("replay-portrait-fullscreen");
        }
        return;
      } else {
        // 网页
        if (this.openAiMode) {
          if (
            !document.fullscreenElement &&
            !document.webkitIsFullScreen &&
            !document.mozFullScreen &&
            !document.msFullscreenElement
          ) {
            if (element.requestFullscreen) {
              document
                .querySelector(".web-normal-mode-fullscreen-cont")
                .requestFullscreen();
            } else if (element.msRequestFullscreen) {
              document
                .querySelector(".web-normal-mode-fullscreen-cont")
                .msRequestFullscreen();
            } else if (element.mozRequestFullScreen) {
              document
                .querySelector(".web-normal-mode-fullscreen-cont")
                .mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
              element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }
            this.isFullScreen = true;
          } else {
            this.handleExitFullscreen();
          }
        } else {
          // 普通看课
          if (
            !document.fullscreenElement &&
            !document.webkitIsFullScreen &&
            !document.mozFullScreen &&
            !document.msFullscreenElement
          ) {
            document
              .querySelector(".web-normal-mode-fullscreen-cont")
              .requestFullscreen();
            this.isFullScreen = true;
          } else {
            this.handleExitFullscreen();
          }
        }
      }
    },
    // H5 非输入题继续沿用 CSS 伪横屏；填空/问答题切回竖屏，保证输入框与系统键盘同向。
    handleQuizInputModeChange(needsPortraitInput) {
      if (!this.isMobile) return;
      if (needsPortraitInput) {
        if (!document.body.classList.contains("replay-landscape")) return;
        this.restoreLandscapeAfterQuizInput = true;
        document.body.classList.remove("replay-landscape");
        document.body.classList.add("replay-portrait-fullscreen");
        return;
      }
      if (!this.restoreLandscapeAfterQuizInput) return;
      document.body.classList.remove("replay-portrait-fullscreen");
      document.body.classList.add("replay-landscape");
      this.restoreLandscapeAfterQuizInput = false;
    },
    handleExitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
      this.isFullScreen = false;
    },
    initDplay() {
      this.dp = this.$refs.dplayer?.dplayer;
      if (!this.dp) return;
      if (this.isH5 && !this.isComponent && !window.isElectron) {
        this.toggleFullScreen();
        // this.dp.fullScreen.request("web");
      }
      this.dp.on("play", () => {
        this.playEnded = false;
        if (this.isFirstPlay) {
          this.lastCallTime = new Date().getTime();
          this.isFirstPlay = false;
        }
        if (!this.userName) {
          // this.setUserName(this.user);
          this.setUserName(this.$store.getters.user);
        }
        this.isPause = false;

        if (!(this.lessonDetail.is_sign_up && this.lessonDetail.is_validity)) {
          this.checkTrialDuration();
        }
        this.startTimer();
      });
      this.dp.on("timeupdate", () => {
        this.$emit("timeupdate", this.dp.video.currentTime);
        if (!(this.lessonDetail.is_sign_up && this.lessonDetail.is_validity)) {
          this.checkTrialDuration();
        }
        // 向上取整
        this.progress = Math.ceil(this.dp.video.currentTime);
      });

      this.dp.on("pause", () => {
        this.stopTimer();
      });
      this.dp.on("ended", () => {
        this.startTrialDuration += Math.ceil(this.dp.video.currentTime);
        // 当前视频播放完毕后
        // 如果还有下个视频，则加载并播放
        if (this.currentIndex < this.videoList.length - 1) {
          this.currentIndex++;
          this.lastProgressTime = 0;
          this.setUrlProgressTime(null);
          const nextUrl = this.videoList[this.currentIndex].url;
          this.dp.switchVideo({
            url: nextUrl,
            type: nextUrl.includes('.m3u8') ? 'hls' : 'normal',
          });
          this.dp.play();
        } else {
          // 本节全部分片播放完毕：上抛给宿主页面，并显示结束卡片
          const index = this.currentIndex;
          this.callKeepAlive(this.videoList[index].url);
          this.stopTimer();
          this.playEnded = true;
          this.$emit("ended", { lessonId: this.lessonId });
        }
      });
      this.dp.on("loadeddata", () => {
        console.log("loadeddata");
        // 检测视频方向并通知父组件
        const video = this.dp.video;
        if (video && video.videoWidth && video.videoHeight) {
          this.isPortraitVideo = video.videoHeight > video.videoWidth;
          this.$emit("videoOrientation", {
            width: video.videoWidth,
            height: video.videoHeight,
          });
        }
      });
      this.dp.on("webfullscreen", () => {
        if (this.isMobile) {
          const isPad = window.innerWidth >= 768 && window.innerHeight >= 500;
          if (this.isPortraitVideo || isPad) {
            document.body.classList.add("replay-portrait-fullscreen");
          } else {
            document.body.classList.add("replay-landscape");
          }
        }
        if (this.$refs["watermarkBox"]) {
          const width = this.$refs["dplayer"].clientWidth;
          const height = this.$refs["dplayer"].clientHeight;
          this.$refs["watermarkBox"].style.width = width + "px";
          this.$refs["watermarkBox"].style.height = height - 200 + "px";
        }
        this.isFullScreen = true;
        if (window.isElectron) {
          let elTopBar = document.querySelector(".topbar");
          if (elTopBar) {
            elTopBar.style.display = "none";
          }
        }
        let navBarEle = document.querySelector(".nav-bar");
        if (navBarEle) {
          navBarEle.style.display = "none";
        }
        let footerEle = document.querySelector(".footer");
        if (footerEle) {
          footerEle.style.display = "none";
        }
      });
      this.dp.on("webfullscreen_cancel", () => {
        this.exitFullscreen();
        this.isFullScreen = false;
        // 删除inline style
        if (this.$refs["watermarkBox"]) {
          this.$refs["watermarkBox"].style.width = "";
          this.$refs["watermarkBox"].style.height = "";
        }
      });
    },
    // 跳转
    jumpTime(time) {
      this.dp.seek(time);
      this.dp.play();
    },
    // 从头学
    afresh() {
      this.currentIndex = 0;
      this.lastProgressTime = 0;
      this.startTrialDuration = 0;
      this.setUrlProgressTime(null);
      const afreshUrl = this.videoList[this.currentIndex]?.url || "";
      this.dp.switchVideo({
        url: afreshUrl,
        type: afreshUrl.includes('.m3u8') ? 'hls' : 'normal',
      });
      this.dp.play();
    },
    // 处理视频播放
    dealPlay() {
      const playUrl = this.videoList[this.currentIndex]?.url || "";
      this.dp.switchVideo({
        url: playUrl,
        type: playUrl.includes('.m3u8') ? 'hls' : 'normal',
      });
      if (this.autoPlayPending) {
        this.autoPlayPending = false;
        this.dp.play();
      }
    },
    // 宿主页面在"播放下一节"后调用：新播放器挂载时还没有视频源，
    // 先登记意图，dealPlay() 拿到地址后自动起播
    requestAutoPlay() {
      this.autoPlayPending = true;
    },
    exitFullscreen() {
      if (this.isMobile) {
        document.body.classList.remove("replay-landscape");
        document.body.classList.remove("replay-portrait-fullscreen");
        this.restoreLandscapeAfterQuizInput = false;
      }
      if (window.isElectron) {
        let elTopBar = document.querySelector(".topbar");
        if (elTopBar) {
          elTopBar.removeAttribute("style");
        }
      }
      let navBarEle = document.querySelector(".nav-bar");
      if (navBarEle) {
        navBarEle.style.display = "block";
      }
      let footerEle = document.querySelector(".footer");
      if (footerEle) {
        footerEle.style.display = "block";
      }
    },
    // 结束卡片：重播本节。多分片课时要先回到第一个分片。
    handleReplay() {
      this.playEnded = false;
      if (!this.dp) return;
      this.setUrlProgressTime(null);
      this.lastProgressTime = 0;
      const firstUrl = this.videoList[0]?.url;
      if (this.videoList.length > 1 && this.currentIndex !== 0 && firstUrl) {
        this.currentIndex = 0;
        this.dp.switchVideo({
          url: firstUrl,
          type: firstUrl.includes(".m3u8") ? "hls" : "normal",
        });
      }
      // 单分片课时没走 switchVideo，必须显式回到 0；多分片时这一下是兜底
      this.dp.seek(0);
      this.dp.play();
    },
    // 非全屏时，在新标签页打开课程的商品详情页
    // 全屏时，变为非全屏，再在新标签页打开课程的商品详情页
    handleEnroll() {
      if (window.isElectron || this.isMobile) {
        if (window.ReplyElectronApi) {
          // 视频播放页
          window.ReplyElectronApi.mainWinJumpUrl({
            name: "ProductDetails",
            params: {
              id: this.courseId,
            },
          });
        } else {
          this.$router.push(`/product-detail/${this.courseId}`);
        }
      } else {
        window.open(`/product-detail/${this.courseId}`);
      }
    },
  },
  watch: {
    initFullScreen: {
      handler: function (newVal) {
        this.isFullScreen = newVal;
      },
      immediate: true,
    },
    user: {
      handler: function (newVal) {
        console.log("user", newVal);
        // this.setUserName(newVal);
      },
      immediate: true,
      deep: true,
    },
    componentParams: {
      handler: function (newVal, oldVal) {
        console.log("componentParams", newVal);
        console.log("componentParams>>>>", oldVal);
        if (!newVal) return;
        if (this.isSameComponentParams(newVal, oldVal)) return;
        const { courseId, unitId, lessonId } = newVal;
        if (!courseId || !unitId || !lessonId) return;
        this.courseId = courseId;
        this.unitId = unitId;
        this.lessonId = lessonId;
        this.playEnded = false;
        // this.getLessonDetail();
        this.checkLesson();
        this.initDplay();
        // 返回按钮展示
        if (!this.$route.query.trial) {
          this.showBack = true;
        }
        this.setUserName(this.$store.getters.user);
      },
      deep: true,
    },
    isFullScreen: {
      handler: function (newVal) {
        this.$emit("changeFullScreen", newVal);
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    // 访录屏
    if (window.screenCaptureSwitch) {
      window.screenCaptureSwitch({
        isEnter: false,
        disableRecord: false,
      });
    }
    clearInterval(this.timerId);
    clearTimeout(this.timerOutId);
    this.exitFullscreen();
    this.dp.fullScreen.cancel("web");
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.page-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  background: #0f172a;
  // #dplayer ::v-deep {
  //   width: 100%;
  //   height: auto;
  //   .dplayer-play-icon {
  //     display: inline-block;
  //   }
  // }
  .handle-box {
    position: absolute;
    height: 120px;
    width: 100%;
    z-index: 1;
    background: linear-gradient(
      180deg,
      rgba(15, 23, 42, 0.95) 0%,
      rgba(15, 23, 42, 0.6) 60%,
      rgba(15, 23, 42, 0) 100%
    );
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    .back-wrap {
      position: absolute;
      left: 24px;
      top: 16px;
      z-index: 1000;
      .back-btn {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        font-size: 20px;
        cursor: pointer;
        color: rgba(203, 213, 225, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
        &:hover {
          background: rgba(255, 255, 255, 0.1);
          color: #fff;
        }
        img {
          width: 24px;
          height: 24px;
        }
      }
    }
    .name {
      color: #ffffff;
      font-weight: 600;
      font-size: 16px;
      width: 100%;
      margin-top: 16px;
      padding: 0 0 0 72px;
      line-height: 28px;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 500px;
      letter-spacing: 0.025em;
    }
  }
}
// 专注模式（侧栏收起时）
.page-container.focus-mode {
  background: #080b12;
  .handle-box {
    background: linear-gradient(
      180deg,
      rgba(8, 11, 18, 0.95) 0%,
      rgba(8, 11, 18, 0.6) 60%,
      rgba(8, 11, 18, 0) 100%
    );
    .back-btn {
      color: rgba(100, 116, 139, 1);
      &:hover {
        color: rgba(203, 213, 225, 1);
        background: rgba(255, 255, 255, 0.1);
      }
    }
  }
}
.component-container {
  // height: auto;
  height: 100%;
}
.org-watermask {
  padding-left: 20px;
  color: #eee;
  opacity: 0.5;
  height: 50px;
  div {
    padding-top: 20px;
    font-size: 20px;
  }
}
.watermask-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 1000;
}
.horse-race {
  width: 100%;
  height: 70%;
}
.scrolling-notice {
  background: rgba($color: #333, $alpha: 0.2);
  color: #fff;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  height: 28px;
  line-height: 28px;
  .scroll-text {
    transform: translateX(100%);
    min-width: 100%;
  }

  .scrolling-text__infinite {
    display: inline-block;
    animation: scroll-left 15s linear infinite;
  }
  .scrolling-text__once {
    display: inline-block;
    animation: scroll-left 15s linear alternate forwards;
  }
}
.hidden-notice {
  opacity: 0;
}
.enroll-btn {
  position: absolute;
  right: 30px;
  top: 30px;
  padding: 0;
  width: 90px;
  height: 40px;
  border: none;
  background: linear-gradient(135deg, #ff7a00 0%, #ff27c0 100%);
  border-radius: 10px;
  font-size: 16px;
  color: #fff;
  z-index: 1000;
}
@keyframes scroll-left {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}
@media (max-width: 767px) {
  .page-container {
    width: auto;
    #dplayer {
      width: 100%;
    }
    .handle-box {
      width: 100%;
      height: 0.9333rem;
      background: linear-gradient(
        180deg,
        rgba(15, 23, 42, 0.95) 0%,
        rgba(15, 23, 42, 0) 100%
      );
      .name {
        font-size: 0.28rem;
        padding: 0 0 0 0.8rem;
        margin-top: 0;
        line-height: 0.9333rem;
        text-align: left;
        max-width: 70%;
      }
      .back-wrap {
        left: 0.2rem;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1000;
        .back-btn {
          width: 0.6rem;
          height: 0.6rem;
          border-radius: 50%;
          cursor: pointer;
          font-size: 0.3rem;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 0.3rem;
            height: 0.3rem;
          }
        }
      }
    }
    .watermask-container {
      position: absolute;
      width: calc(100% - 0.54rem);
      height: 5rem;
      left: 0;
      top: 0;
      .scrolling-notice {
        height: 0.3733rem;
        line-height: 0.3733rem;
        font-size: 0.2133rem;
      }
    }
    .org-watermask {
      padding-left: 0.4rem;
      font-size: 0.2rem;
      height: 0.5rem;
      div {
        padding-top: 0;
        font-size: 0.3rem;
      }
    }
  }
}

.page-container__full {
  position: fixed;
  left: 0;
  top: 0;
  padding: 0;
  .watermask-full-screen {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 100000000;
    ::v-deep .watermask-container {
      width: 100%;
    }
  }
}

// electron-视频播放页
.page-container__electron {
  .enroll-btn {
    top: 60px;
    z-index: 9999999;
    -webkit-app-region: none;
  }
}
</style>
<style lang="scss">
.web-fullscreen-player {
  .dplayer-full-icon {
    display: none !important;
  }
  .dplayer-controller .dplayer-icons .dplayer-full .dplayer-full-in-icon {
    position: static;
    display: inline-block !important;
  }
}
</style>
<style lang="scss">
.replay-landscape {
  width: 100vh;
  height: 100vw;
  overflow: hidden;
  transform-origin: top left;
  transform: rotate(90deg) translateY(-100%);
  transition: all 0.3s;
  .tabs-container {
    display: none !important;
  }
  .course-info-area {
    display: none !important;
  }
}
// 竖屏视频全屏：不旋转，全屏覆盖
.replay-portrait-fullscreen {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  .tabs-container {
    display: none !important;
  }
  .tabs-box {
    display: none !important;
  }
  .course-info-area {
    display: none !important;
  }
  footer.footer {
    display: none !important;
  }
  .page-container {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999999;
  }
  .video-area {
    height: 100vh !important;
  }
}
</style>
